export const MEDICAL_CATEGORY_CONFIG = {
  DEFAULT_DISPLAY_SIZE: 10,
  SKELETON_COUNT: 10,
} as const;

export const CATEGORY_GRID_STYLES = {
  CONTAINER: 'flex w-full flex-col',
  GRID: 'grid grid-cols-5 gap-0 px-[12px] md:px-[0px] sm:grid-cols-10 sm:gap-[24px]',
  ITEM_BASE:
    'flex min-h-[88px] cursor-pointer flex-col items-center justify-center gap-[12px] rounded-[8px] border border-gray-100 p-[8px] sm:min-h-[108px] aspect-square',
  SKELETON_ITEM:
    'flex w-full cursor-pointer flex-col items-center justify-center gap-[12px] rounded-[8px] border border-gray-100 p-[8px] sm:min-h-[108px] aspect-square',
} as const;

export const CATEGORY_ITEM_STYLES = {
  ICON_CONTAINER:
    'flex aspect-square h-[48px] w-[48px] sm:h-[64px] sm:w-[64px] items-center justify-center rounded-[16px] sm:rounded-[21px] bg-gray-20 p-[12%] sm:p-[20%] md:p-[18%] lg:p-[20%]',
  ICON: 'h-full w-full object-contain',
  NAME: 'typography-ui-13m sm:typography-ui-17m flex h-[16px] items-center justify-center whitespace-nowrap break-keep text-center text-gray-700 leading-tight sm:h-[20px]',
} as const;

export const SKELETON_STYLES = {
  ICON_CONTAINER:
    'flex aspect-square h-[48px] w-[48px] sm:h-[64px] sm:w-[64px] items-center justify-center rounded-[21px] bg-gray-50 p-[20%]',
  ICON_PLACEHOLDER: 'aspect-square bg-gray-50',
  NAME_PLACEHOLDER: 'h-[16px] w-[48px] rounded-[4px] bg-gray-50 sm:h-[20px] sm:w-[64px]',
} as const;
